export default __webpack_public_path__ + "static/media/rsplay_feature_wide.6952c066.png";